<template>
  <div class="container">
    <van-nav-bar :title="$route.query.name" left-text="返回" right-text="主页"
      @click-right="handleHome" @click-left="onClickLeft" left-arrow
    />
    <van-search v-model="value" placeholder="请输入搜索关键词" show-action
      @search="onSearch" @cancel="onCancel"
    />
    <div class="box">
      <van-tag round type="primary" v-for="item in list" :key="item.id" @click="goto(item)">
        <span>{{item.areaname}}</span>
      </van-tag>
    </div>
    <div class="con">
      <div class="card" v-for="(el, index) in dbList" :key="index">
        <van-row>
          <van-col span="4">
            <div v-if="el.dbHeadicon && el.dbHeadicon.indexOf('http') >= 0">
              <img :src="el.dbHeadicon" class="dbimg"/>
            </div>
            <div v-if="el.dbHeadicon && el.dbHeadicon.indexOf(1) >= 0">
              <img :src="http + el.dbHeadicon + '&type=1'" class="dbimg" />
            </div>
            <div v-else>
              <img :src="require('@/assets/images/7.png')" class="dbimg" />
            </div>
          </van-col>
          <van-col span="20">
            <div class="dbname">
              <span>{{ el.dbName }}</span>
              <span class="sex">{{ el.sex }}</span>
              <span class="level">{{ el.dbjb }}</span>
            </div>
            <div class="dbdetail">
              <span v-if="el.company && el.company !== ''">{{ el.company }}</span>
              <span v-else>暂无代表相关信息</span>
            </div>
          </van-col>
        </van-row>
        <div class="bottom">
          <div class="bottomLeft">
            <van-icon name="search" style=" vertical-align: middle; font-size:22px" />
            <span class="advice" @click="gotoTjy(el)">查详情</span>
          </div>
          <div class="bottom" @click="toLink(el)">
            <van-icon name="edit" style=" vertical-align: middle;font-size:22px"/>
            <span class="advice">提建议</span>
          </div>
        </div>
      </div>
      <van-empty v-if="dbList.length==0" description="暂无信息" />
    </div>
  </div>
</template>
<script>
import request from '@/api/home.js'
export default {
  data () {
    return {
      code: 0,
      value: '',
      list: [],
      dbList: [],
      http: this.$api
    }
  },
  methods: {
    toLink (val) {
      this.$router.push({
        path: '/suggess',
        query: {
          id: val.id,
          dbName: val.dbName
        }
      })
    },
    handleHome () {
      this.$router.push('/home')
    },
    async onSearch () {
      const pageIndex = 1
      const pageSize = 200
      const res = await request.getDqPeople(this.value.trim(), this.$route.query.code, pageIndex, pageSize)
      console.log(res)
      this.dbList = res.list
    },
    onCancel () {
      this.getTree(this.$route.query.code)
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    // 获取组织机构树
    async getTree (pid) {
      const res = await request.getOriginChildTree(pid)
      res.forEach((item, index) => {
        if (item.areaname.indexOf('本级') !== -1) {
          res.splice(index, 1)
        }
      })
      this.list = res
    },
    async gotoTjy (item) {
      this.$router.push({
        path: '/Dbinfo',
        query: {
          id: item.id,
          dbName: item.dbName
        }
      })
    },
    async goto (item) {
      this.$router.push({
        path: '/llzList',
        query: item
      })
    }
  },
  created () {
    this.getTree(this.$route.query.code)
  }
}
</script>

<style scoped lang="less">
.box {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
  padding: 0 10px;
  /deep/.van-tag {
    width: 27%;
    height: 60px;
    font-size: 30px;
    margin: 15px 10px;
    span {
      margin: 0 auto;
    }
  }
}
.con {
  margin-top: 0px;
  padding: 10px;
  background: rgb(243, 243, 243);
  .card {
    margin: 20px auto;
    background: #fff;
    padding: 20px 10px;
  }
  .dbimg {
    width: 80%;
    height: 90px;
  }
  .dbname {
    font-size: 34px;
    font-weight: 600;
    border-bottom: 1px solid rgb(218, 218, 218);
    padding-bottom: 8px;
    .sex {
      font-size: 28px;
      color: #727071;
      font-family: '楷体';
      padding-left: 20px;
    }
    .level {
      font-size: 28px;
      color: #727071;
      font-family: '楷体';
      padding-left: 20px;
    }
  }
  .dbdetail {
    font-size: 28px;
    line-height: 40px;
    margin-top: 10px;
    color: #a5a2a2;
    font-family: Source Han Sans CN;
  }
  .adviceBtn {
    padding-top: -10px;
  }
  .bottom {
    margin-top: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bottomLeft{
    margin-left: 20px;
  }
  .advice {
    font-size: 26px;
    padding-left: 10px;
    font-family: Source Han Sans CN;
  }
  .information{
    font-size: 45px;
    line-height: 40px;
    margin-top: 10px;
    color: #a5a2a2;
    font-family: Source Han Sans CN;
  }
}
</style>
